import React from "react";
import { MockupSlot } from "./MockupSlot";
import { parableElements, parablePages } from "../data/landing";
const markers = ["bg-azure", "bg-terracotta", "bg-sage-deep"];
export function ContentsSection() {
  return <section id="contenu" className="bg-cream pb-16 md:pb-24" data-id="element-41" data-mp="34lsoscxt8bms">
      <div className="mx-auto max-w-6xl px-5" data-id="element-42" data-mp="39jc1h8ev0gcm">
        <div className="mx-auto max-w-3xl text-center" data-id="element-43" data-mp="39j2bvlxq8b7g">
          <h2 className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.6rem]" data-id="element-44" data-mp="2ctuzp4izzeg7">
            Découvrez tout ce que contient votre Méga Pack
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-45" data-mp="2ltzw6jmnksfl">
            Une collection pensée pour faire de la transmission de la foi un
            moment simple, joyeux et partagé.
          </p>
        </div>

        <div className="mt-12 rounded-[2rem] bg-azure-light px-6 py-10 md:mt-16 md:px-12 md:py-14" data-id="element-46" data-mp="1t63zvg0zx2jc">
          <div className="grid gap-10 lg:grid-cols-[1fr_0.8fr] lg:items-end" data-id="element-47" data-mp="1y3neih1lvhbt">
            <div data-id="element-48" data-mp="1ocszo0ijplkx">
              <h3 className="font-display text-2xl font-bold uppercase leading-tight text-ink md:text-4xl" data-id="element-49" data-mp="1odatyrlndpq7">
                <span className="text-terracotta" data-id="element-50" data-mp="1kcijxw4ybgsv">Plus de 50</span> paraboles
                chrétiennes illustrées
              </h3>
              <p className="mt-4 max-w-xl leading-relaxed text-ink-soft md:text-lg" data-id="element-51" data-mp="1fimp32jzia1x">
                De jolies paraboles mettant en scène des personnages attachants
                et des situations que les enfants peuvent comprendre et
                retrouver dans leur quotidien.
              </p>
            </div>
            <div data-id="element-52" data-mp="wlv9p47kcf35">
              <p className="text-sm font-extrabold text-azure" data-id="element-53" data-mp="wld2xdn9yigz">
                Dans chaque parabole :
              </p>
              <ul className="mt-3 divide-y divide-ink/10 border-y border-ink/10" data-id="element-54" data-mp="rntp2euho7pk">
                {parableElements.map((el, i) => <li key={el} className="flex items-center gap-3 py-3 font-display text-lg font-semibold text-ink" data-id="element-55" data-mp="2qxtix65vhaz1" data-mpi={i}>
                    <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${markers[i]}`} aria-hidden="true" data-id="element-56" data-mp="354mt7rsnf3kb" />
                    {el}
                  </li>)}
              </ul>
            </div>
          </div>

          <ul className="-mx-6 mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto px-6 pb-2 md:mx-0 md:grid md:grid-cols-3 md:gap-6 md:overflow-visible md:px-0" aria-label="Aperçu des pages de paraboles" data-id="element-57" data-mp="314w19krdyhe7">
            {parablePages.map((page, i) => <li key={i} className="w-[70%] shrink-0 snap-start md:w-auto" data-id="element-58" data-mp="3eu6a4rwswncj" data-mpi={i}>
                <MockupSlot src={page.src} label={page.title} hint="Page réelle à intégrer" className="aspect-[3/4] w-full bg-cream/80" data-id="element-59" data-mp="3jtszfzpwlu1p" />
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}